import { jwtDecode } from 'jwt-decode';
import { AccessTokenDecoded, AuthProfile } from '../../models/auth.model';
import { TokenRegion } from '../../models/region.model';

export function mapAccessTokenToModel(token: string): AuthProfile {
  const accessToken = jwtDecode<AccessTokenDecoded>(token);

  const roles = Array.isArray(accessToken.role)
    ? [...accessToken.role]
    : [accessToken.role];

  const businessEntities = Array.isArray(accessToken.businessentities)
    ? [...accessToken.businessentities]
    : [accessToken.businessentities];

  const regions: TokenRegion[] = JSON.parse(accessToken.regions || '[]');

  return {
    email: accessToken.email,
    roles,
    businessEntities,
    regions,
    token,
    tokenExpiration: accessToken.exp,
    tokenExpirationDate: new Date(accessToken.exp * 1000),
  };
}
